import { Link } from "react-router-dom";
import Modal from '@mui/material/Modal';
import { TextField } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import Dropdown from 'react-bootstrap/Dropdown';
import Typography from '@mui/material/Typography';
import Select, { components } from "react-select";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState, useRef } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import 'react-circular-progressbar/dist/styles.css';
import { toggleModal } from "../../../reducers/modalReducer";
import { getRequest, postRequest, showMessage } from "../../../config";


// Dummy data for the report table
const dummyUsers = [
    {
        id: 1,
        name: "John Smith",
        firm: "Venture Capital Partners",
        type: "Investor",
        email: "john.smith@vcp.com",
        lastLogin: "2024-10-15",
        access: { keyShareholderDocs: true }
    },
    {
        id: 2,
        name: "Sarah Johnson",
        firm: "Tech Innovations Ltd",
        type: "Company",
        email: "sarah.j@techinnovations.com",
        lastLogin: "2024-10-20",
        access: { keyShareholderDocs: false }
    },
    {
        id: 3,
        name: "Michael Brown",
        firm: "Legal Advisory Group",
        type: "Advisor",
        email: "m.brown@legaladvisory.com",
        lastLogin: "2024-10-18",
        access: { keyShareholderDocs: true }
    },
    {
        id: 4,
        name: "Emma Davis",
        firm: "External Consultants Inc",
        type: "External",
        email: "emma.davis@external.com",
        lastLogin: "2024-10-12",
        access: { keyShareholderDocs: false }
    },
    {
        id: 5,
        name: "Robert Wilson",
        firm: "Growth Equity Fund",
        type: "Investor",
        email: "r.wilson@growthequity.com",
        lastLogin: "2024-10-21",
        access: { keyShareholderDocs: true }
    }
];

const sections = [
    "Key Shareholder, Investor Documents",
    "Commercial Activities",
    "Legal",
    "Property",
    "Intellectual Property",
    "Insurance",
    "Corporate Structure",
    "State Aid",
    "Finance",
    "GDPR",
    "Shares, Share Options",
    "Taxation",
    "Social Media",
    "Key People",
    "HR",
    "ESG",
    "Key Advisors",
    "IT Systems",
    "Regulatory",
    "Standards"
];

export default function ShareDiligencePack({ company, setCompanyDashboardTab, setTab }) {

    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const modal = useSelector(state => state.modal);

    const [users, setUsers] = useState(dummyUsers);

    const handleSendSecureLink = (userEmail, userName) => {
        console.log(`Sending secure diligence pack link to ${userName} (${userEmail})`);
        showMessage(`Secure link sent to ${userName}`);
    };

    const handleCheckboxChange = (userId, section) => {
        // Only allow changes to "Key Shareholder and Investor Documents" for now
        if (section === "Key Shareholder and Investor Documents") {
            setUsers(users.map(u =>
                u.id === userId
                    ? { ...u, access: { ...u.access, keyShareholderDocs: !u.access.keyShareholderDocs } }
                    : u
            ));
        }
    };

    return (
        <>
            <div className="w100">
                <div className="df jcc my2rem">
                    <Link onClick={() => setTab('diligence-pack')} className="pa r0 cp df aic jcc px2rem py0-75rem br25px bg4 c1 fs1rem">
                        <svg className="mr0-5rem" width="16" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z" fill="#FFFFFF" />
                        </svg>
                        Back to Diligence Pack
                    </Link>
                    <h2 className="c15 fs1-5rem tac">Share Diligence Pack</h2>
                </div>

                {/* Table Container */}
                <div className="w100 bg1 br15px p2rem shadow bsbb oa share-diligence-table">
                    <table className="w100 bw1px bss bo16 c15">
                        <thead>
                            <tr>
                                <th className="bg5 tac fw600 fs0-875rem py1rem px0-75rem bw1px bss bo16">Name</th>
                                <th className="bg5 tac fw600 fs0-875rem py1rem px0-75rem bw1px bss bo16">Firm</th>
                                <th className="bg5 tac fw600 fs0-875rem py1rem px0-75rem bw1px bss bo16">Type</th>
                                <th className="bg5 tac fw600 fs0-875rem py1rem px0-75rem bw1px bss bo16">Email Address</th>
                                <th className="bg5 tac fw600 fs0-875rem py1rem px0-75rem bw1px bss bo16">Action</th>
                                <th className="bg5 tac fw600 fs0-875rem py1rem px0-75rem bw1px bss bo16">Last Login</th>
                                {sections.map((section, idx) => (
                                    <th key={idx} className="bg5 tac fw600 fs0-75rem py1rem px0-75rem bw1px bss bo16">
                                        {section.includes(',')
                                            ? <>{section.split(',')[0]},<br />{section.split(',')[1]}</>
                                            : section
                                        }</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user, userIdx) => (
                                <tr key={user.id}>
                                    <td className="tac fs0-875rem py1rem px0-75rem bw1px bss bo5">{user.name}</td>
                                    <td className="tac fs0-875rem py1rem px0-75rem bw1px bss bo5">{user.firm}</td>
                                    <td className="tac fs0-875rem py1rem px0-75rem bw1px bss bo5">{user.type}</td>
                                    <td className="tac py1rem px0-75rem bw1px bss bo5">
                                        <a
                                            href={`mailto:${user.email}`}
                                            className="c4 fs0-875rem c4-hover"
                                            style={{ textDecoration: 'none' }}
                                        >
                                            {user.email}
                                        </a>
                                    </td>
                                    <td className="tac py1rem px0-75rem bw1px bss bo5">
                                        <button
                                            onClick={() => handleSendSecureLink(user.email, user.name)}
                                            className="cp bg1 bw0"
                                            title="Send secure Diligence Pack link"
                                            style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17.5 5.83333V14.1667C17.5 15.5474 16.3807 16.6667 15 16.6667H5C3.61929 16.6667 2.5 15.5474 2.5 14.1667V5.83333M17.5 5.83333C17.5 4.45262 16.3807 3.33333 15 3.33333H5C3.61929 3.33333 2.5 4.45262 2.5 5.83333M17.5 5.83333V5.98619C17.5 6.60451 17.2054 7.18634 16.7007 7.55678L10.7007 11.8901C10.2803 12.1967 9.71967 12.1967 9.29933 11.8901L3.29933 7.55678C2.79456 7.18634 2.5 6.60451 2.5 5.98619V5.83333" stroke="#4A67FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </td>
                                    <td className="tac fs0-875rem py1rem px0-75rem bw1px bss bo5">{user.lastLogin}</td>
                                    {sections.map((section, idx) => (
                                        <td key={idx} className="tac py1rem px0-75rem bw1px bss bo5">
                                            <input
                                                type="checkbox"
                                                checked={idx === 0 ? user.access.keyShareholderDocs : false}
                                                onChange={() => handleCheckboxChange(user.id, section)}
                                                disabled={idx !== 0}
                                                className={`cp ${idx !== 0 ? 'op30 cna' : ''}`}
                                                style={{
                                                    width: '18px',
                                                    height: '18px',
                                                    cursor: idx === 0 ? 'pointer' : 'not-allowed'
                                                }}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Info Note */}
                <div className="mt1rem c12 fs0-875rem tac">
                    <p>* Only "Key Shareholder and Investor Documents" access can be modified in this version</p>
                </div>
            </div>
        </>
    );
}